export function prependCdnResourcesUrl(path: string) {
  return `${globalThis.CDN_URL}/resources${path}`;
}
